<template>
  <div o-Container>
  </div>
</template>


<script>
  export default {
    name: "login",
    data() {
      return {
        octopus: this.$parent.octopus
      }
    },
    created: function () {
      this.octopus.tips.debug("Login.vue执行了created事件。");
    },
    mounted: function () {
      this.octopus.tips.debug("Login.vue执行了mounted事件。");
    },
    updated: function () {
      this.octopus.tips.debug("Login.vue执行了updated事件。");
    },
    activated: function () {
      console.log('pc login');

      // 统一的官网登录账号，无权限，就是为了访问用。
      this.octopus.passport.name = "herodoo_website";
      this.octopus.passport.password = "herodoo_website";
      this.octopus.passport.encryption = false;
      this.login();


      this.octopus.tips.debug("Login.vue执行了activated事件。");
    },
    deactivated: function () {
      this.octopus.tips.debug("Login.vue执行了deactivated事件。");
    },
    // 和computed的区别在于computed只有在内部使用的变量发生变化时重新计算。
    // 而methods是只要渲染则立刻会执行。
    methods: {
      // 登录前置审核
      login: function () {
        // 提交的时候判断是否是已经加密，如果没有，则提交登录的时候对数据进行加密。
        if (!this.octopus.passport.encryption) {
          // 更新时间戳（毫秒）
          this.octopus.passport.timespan = (new Date()).valueOf();
          this.octopus.passport.password = this.octopus.tools.md5(this.octopus.passport.name
            + "marco" + this.octopus.passport.timespan + "july" + this.octopus.passport.password);
        }
        // 触发登录函数
        this.auto();
      },
      auto: function () {
        let o = this;
        // 获取护照数据，不管成功与否，全部设置为true。
        this.octopus.request.security.passport.get(function (passport_data) {
          o.octopus.passport.encryption = true;
          if (!o.octopus.tools.IsNullOrEmpty(passport_data) && passport_data.status.code == 200) {
            if (passport_data.content && passport_data.content.authorization && passport_data.content.authorization.project) {
              o.octopus.request.security.token.get(function (token_data) {
                if (!o.octopus.tools.IsNullOrEmpty(token_data) && token_data.status.code == 200) {
                  // 调试时打印获取到权限数据。
                  o.octopus.tips.debug("Login页面Auto更新护照：" + JSON.stringify(passport_data));
                  // 执行跳转系统内页
                  o.octopus.router.jump("/View/Home/Page");
                  // 这个是可以的，操。
                  // o.octopus.vue.$router.push("/View/Home/Page");
                } else {
                  o.octopus.tips.error(token_data);
                }
              });
            } else {
               o.octopus.tips.error("请联系管理员分配正确的可访问权限");
            }

          } else {
            o.octopus.tips.error(passport_data);
          }

        });
      },
    },
    props: ["oData"]//接收App.vue传入的octopus对象，但是目前已经用 octopus: this.$parent.octopus代替
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Main/Viewform/Login/Page.vue